var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMhoSortIconWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "9px",
    viewBox: "0 0 5 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 11 Copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Provider-Dashboard-Comp-V2",
    transform: "translate(-874.000000, -467.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(874.000000, 467.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    transform: "translate(2.500000, 2.000000) rotate(-360.000000) translate(-2.500000, -2.000000) ",
    points: "2.5 9.09494702e-13 5 4 0 4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle-Copy",
    transform: "translate(2.500000, 7.000000) rotate(-180.000000) translate(-2.500000, -7.000000) ",
    points: "2.5 5 5 9 0 9"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMhoSortIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mho-sort-icon-white.86a95503a74c4221aafcbe009731ec47.svg";